import { h as __h } from "preact";
/** @import { ComponentChildren } from "preact"; */

import html from "~/util/html.js";
import Icon from "./Icon.js";
import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./ErrorPage.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./ErrorPage.module.css", import.meta.url);
const css = adopt(sheet);

/**
 * @typedef {object} Props
 * @property {string} title
 * @property {string} icon
 * @property {ComponentChildren} [children]
 */

/** @param {Props} props */
export default function ErrorPage(props) {
  const {
    title,
    icon,
    children
  } = props;
  return __h("div", {
    "class": css.wrapper
  }, __h("h2", {
    "class": css.title
  }, __h(Icon, {
    name: icon,
    size: 20
  }), __h("span", {}, title)), __h("div", {
    "class": css.content
  }, children));
}

/**
 * @typedef {object} ErrorMessageProps
 * @property {string} message
 */

/** @param {ErrorMessageProps} props */
export function ErrorMessage(props) {
  return [" ", __h("p", {
    "class": css.message
  }, props.message), " "];
}